import Flags from 'js/src/libs/flags';

/**
 * The reserved `scene_design_id` that asks for a motion graphics scene — a bespoke animated graphic
 * — in place of one of the template's stock designs. Passing it to the ordinary scene-adding tools
 * keeps motion graphics scenes a *kind of scene* rather than a parallel set of near-duplicate tools,
 * which is also how the model reasons about them most reliably.
 */
export const MOTION_GRAPHICS_SCENE_DESIGN_ID = 'motion_graphics_design';

/**
 * Whether this call is asking for a motion graphics scene. The codeo flag is part of the question,
 * not a separate check callers have to remember: `add_scene` and `add_voiceover_scene` are
 * registered for everyone, so without it the reserved id has to fall through to ordinary design
 * validation and be rejected like any other unknown design.
 */
export function isMotionGraphicsSceneRequested(sceneDesignId: string | undefined): boolean {
    return (
        sceneDesignId?.trim().toLowerCase() === MOTION_GRAPHICS_SCENE_DESIGN_ID &&
        Flags.canUseCodeo()
    );
}
